import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { TickerData } from 'types/Ticker';

import type { SelectedProductStore } from './selectedProduct.types';

const useSelectedProductStoreBase = create<SelectedProductStore>()(
  devtools(
    set => ({
      // #region States
      state: {
        spotPrice: undefined,
        markPrice: {
          implied_volatility: undefined,
          product_id: undefined,
          price: undefined,
          price_band: undefined,
        },
        selectedPriceAlertCoin: {
          indexSymbol: undefined,
          spotPrice: undefined,
        },
        fundingData: {
          estimatedFundingRate: undefined,
          nextFundingRealization: undefined,
          fundingRate: undefined,
          fundingInterval: undefined,
        },
      },

      // #endregion

      // #region Actions
      actions: {
        updateMarkPrice: (data: {
          product_id: number;
          price: string;
          price_band: TickerData['price_band'];
          implied_volatility: string;
        }) => {
          set(
            store => ({
              state: {
                ...store.state,
                markPrice: {
                  product_id: data.product_id,
                  price: data.price,
                  price_band: data.price_band,
                  implied_volatility: data.implied_volatility,
                },
              },
            }),
            false,
            'updateMarkPrice' // -> This is used for devtools
          );
        },

        updateSpotPrice: (price: number) => {
          set(
            store => ({
              state: {
                ...store.state,
                spotPrice: price,
              },
            }),
            false,
            'updateSpotPrice' // -> This is used for devtools
          );
        },

        updateSelectedCoinSpotPrice: (data: { p: number }) => {
          set(
            store => ({
              state: {
                ...store.state,
                selectedPriceAlertCoin: {
                  ...store.state.selectedPriceAlertCoin,
                  spotPrice: Number(data.p),
                },
              },
            }),
            false,
            'updateSelectedCoinSpotPrice' // -> This is used for devtools
          );
        },

        updateSelectedCoinIndexSymbol: (data: { symbol: string }) => {
          set(
            store => ({
              state: {
                ...store.state,
                selectedPriceAlertCoin: {
                  ...store.state.selectedPriceAlertCoin,
                  indexSymbol: data.symbol,
                },
              },
            }),
            false,
            'updateSelectedCoinIndexSymbol' // -> This is used for devtools
          );
        },

        updateProductFundingData: (data: {
          predicted_funding_rate: string;
          funding_rate: string;
          next_funding_realization: string;
          funding_interval: string;
        }) => {
          set(
            store => ({
              state: {
                ...store.state,
                fundingData: {
                  ...store.state.fundingData,
                  estimatedFundingRate: Number(data.predicted_funding_rate),
                  nextFundingRealization: Number(data.next_funding_realization),
                  fundingRate: Number(data.funding_rate),
                  fundingInterval: Number(data.funding_interval),
                },
              },
            }),
            false,
            'updateProductFundingData' // -> This is used for devtools
          );
        },
      },

      // #endregion
    }),
    {
      name: 'SelectedProductStore',
    }
  )
);

export { useSelectedProductStoreBase };
